import { render, staticRenderFns } from "./DecisionForecast.vue?vue&type=template&id=48f08672&"
import script from "./DecisionForecast.vue?vue&type=script&lang=js&"
export * from "./DecisionForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports